"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("babel-types");
exports.runtimePath = 'continuations/dist/runtime';
/**
 * Produces a string that represents the source location of `path`.
 *
 * @param functionName the name of the enclosing function
 * @param path the path of the node whose location to return
 * @param opts compiler options, for the source map
 */
function locationString(functionName, path, opts) {
    let result = [];
    const loc = t.isAssignmentExpression(path.node) ? path.node.right.loc :
        path.node.loc;
    // TODO(arjun): handleNew triggers this case
    if (loc !== undefined) {
        const line = opts.sourceMap.getLine(loc.start.line, loc.start.column);
        if (typeof line === 'number') {
            result.push(`Line ${line}`);
        }
    }
    if (typeof functionName === 'string') {
        result.push(`: in ${functionName}`);
    }
    return result.join('');
}
exports.locationString = locationString;
function isStopifyAnnotation(v) {
    return /^@stopify flat$/.test(v);
}
exports.isStopifyAnnotation = isStopifyAnnotation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9oZWxwZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsaUNBQWlDO0FBRXBCLFFBQUEsV0FBVyxHQUFHLDRCQUE0QixDQUFDO0FBRXhEOzs7Ozs7R0FNRztBQUNILFNBQWdCLGNBQWMsQ0FBQyxZQUFnQyxFQUMzRCxJQUFzQixFQUN0QixJQUFrQjtJQUVsQixJQUFJLE1BQU0sR0FBYSxFQUFFLENBQUM7SUFFMUIsTUFBTSxHQUFHLEdBQUcsQ0FBQyxDQUFDLHNCQUFzQixDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDckUsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUM7SUFDaEIsNENBQTRDO0lBQzVDLElBQUksR0FBRyxLQUFLLFNBQVMsRUFBRTtRQUNyQixNQUFNLElBQUksR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ3RFLElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFO1lBQzVCLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxJQUFJLEVBQUUsQ0FBQyxDQUFDO1NBQzdCO0tBQ0Y7SUFFRCxJQUFJLE9BQU8sWUFBWSxLQUFLLFFBQVEsRUFBRTtRQUNwQyxNQUFNLENBQUMsSUFBSSxDQUFDLFFBQVEsWUFBWSxFQUFFLENBQUMsQ0FBQztLQUNyQztJQUNELE9BQU8sTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUN6QixDQUFDO0FBcEJILHdDQW9CRztBQUlILFNBQWdCLG1CQUFtQixDQUFDLENBQVM7SUFDM0MsT0FBTyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDbkMsQ0FBQztBQUZELGtEQUVDIn0=


//////////////////
// WEBPACK FOOTER
// .-continuations-compiler/dist/src/helpers.js
// module id = 58
// module chunks = 0